import AxiosInstance from './http-utils';

const API_ENDPOINT="";
const AxiosClass: any = AxiosInstance;
const Axios = new AxiosClass( API_ENDPOINT);

export default Axios;
